import React, { useState } from 'react';
import { Button, Modal, ModalBody, ModalFooter, Col, CardBody, Row } from 'reactstrap';
import { ModalHeader } from 'semantic-ui-react';
import ImageUpload from "./CustomUpload/ImageUpload";
import Axios from 'axios';
import { Services } from '../../../../Services'

function AddDocuments(props) {
	const [File, setFile] = useState([]);
	const [openModal, setopenModal] = useState(false);
	function toggle() {
		setopenModal(!openModal);
	}

	function getFile(f) {
		setFile(f[0].file)
	}

	const updateImg = () => {
		let formData = new FormData();
		formData.append('image', File)
		Axios.post(`${Services.Documents.path}Documents/uploadDocumment/`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
			.then(response => {
				let data = response.data.data
				saveDocument(data)
			}).catch(error => {
				console.log('hubo error?', error);
			})
	}

	const saveDocument = (data) => {
		let body = { urlDoc: data.url, Name: data.blobName, idContainer: props.idContainer, Type: data.Type }
		Axios.post(`${Services.Documents.path}Documents/saveDocumment`, body)
			.then(response => {
				props.GetDocumments()
			}).catch(error => {
				console.log('hubo error?', error);
			})
	}


	return (
		<React.Fragment>
			<Col style={{ textAlignLast: 'right' }}>
				<CardBody>
					<Button
						color="primary"
						onClick={toggle}
					>
						<i className='fas fa-file mr-2' />Add Documment
					</Button>
				</CardBody>
			</Col>
			<CardBody>
				<Modal
					isOpen={openModal}
					style={{ maxWidth: '1600px', width: '30%' }}
				>
					<ModalHeader>
						<CardBody>
							<p>Add New Documment</p>
						</CardBody>
					</ModalHeader>
					<ModalBody>
						<CardBody style={{ textAlignLast: 'center' }}>
							<i
								style={{ fontSize: '7em', color: 'orange' }}
								className='fas fa-file'></i>
						</CardBody>
						<Row>
							<Col sm='12'>
								<CardBody>
									<ImageUpload
										callFile={(f) => { getFile(f) }}
										updateImg={updateImg}
									/>
								</CardBody>
							</Col>
						</Row>
					</ModalBody>
					<ModalFooter style={{ justifyContent: 'center' }}>
						<Button
							color="primary"
							onClick={() => {
								updateImg();
								setopenModal(false);
							}}
						>
							<i className='fas fa-plus-circle mr-2' />Upload</Button>{' '}
						<Button
							color="danger"
							onClick={() => { setopenModal(false); props.onCancel(); }}>
							<i className='fas fa-window-close mr-2' />Cancel</Button>
					</ModalFooter>
				</Modal>
			</CardBody>
		</React.Fragment>
	);
};


AddDocuments.defaultProps = {
	onCancel: () => { },
};

export default AddDocuments;